//#region Dependencies
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Main from "./Main";
import MyAccount from "./MyAccount";

import Users from "./Users";
import ViewUser from "./Users/View";
import CreateUser from "./Users/Create";

import Patients from "./Patients";
import ViewPatient from "./Patients/View";
import CreatePatient from "./Patients/Create";
import PatientSoftwareList from "./Patients/SoftwareList";
import Softwares from "./Softwares";
import CreateSoftware from "./Softwares/Create";
import ViewSoftware from "./Softwares/View";
import Organizations from "./Organizations";
import CreateOrganization from "./Organizations/Create";
import ViewOrganization from "./Organizations/View";
import ViewOrganizationMembers from "./Organizations/View/Members";
import { UserPermissions } from "../App";
import FAQ from "./FAQ";
import Extensions from "./Extensions";
import CreateExtension from "./Extensions/Create";
import ViewExtension from "./Extensions/View";
//#endregion

interface Props {
  userPermissions: UserPermissions;
}
const Router: React.FC<Props> = ({ userPermissions }) => {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route
        path={process.env.PUBLIC_URL}
        element={<Main userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/"}
        element={<Main userPermissions={userPermissions} />}
      />

      {/* Users */}
      <Route
        path={process.env.PUBLIC_URL + "/Users"}
        element={<Users userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Users/Create"}
        element={<CreateUser userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Users/View/:username"}
        element={<ViewUser userPermissions={userPermissions} />}
      />

      {/* Patients */}
      <Route
        path={process.env.PUBLIC_URL + "/Patients"}
        element={<Patients userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Patients/Create"}
        element={<CreatePatient userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Patients/View/:username"}
        element={<ViewPatient userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Patients/SoftwareList/:username"}
        element={<PatientSoftwareList userPermissions={userPermissions} />}
      />

      {/* Organizations */}
      <Route
        path={process.env.PUBLIC_URL + "/Organizations"}
        element={<Organizations userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Organizations/Create"}
        element={<CreateOrganization userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Organizations/View/:organization"}
        element={<ViewOrganization userPermissions={userPermissions} />}
      />
      <Route
        path={
          process.env.PUBLIC_URL + "/Organizations/View/:organization/Members"
        }
        element={<ViewOrganizationMembers userPermissions={userPermissions} />}
      />

      {/* Software */}
      <Route
        path={process.env.PUBLIC_URL + "/Softwares"}
        element={<Softwares userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Softwares/Create"}
        element={<CreateSoftware userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Softwares/View/:softwareID"}
        element={<ViewSoftware userPermissions={userPermissions} />}
      />
      
      {/* Extensions */}
      <Route
        path={process.env.PUBLIC_URL + "/Extensions"}
        element={<Extensions userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Extensions/Create"}
        element={<CreateExtension userPermissions={userPermissions} />}
      />
      <Route
        path={process.env.PUBLIC_URL + "/Extensions/View/:extensionID"}
        element={<ViewExtension userPermissions={userPermissions} />}
      />

      {/* FAQ */}
      <Route
        path={process.env.PUBLIC_URL + "/FAQ"}
        element={<FAQ userPermissions={userPermissions} />}
      />

      {/* My Account */}
      <Route
        path={process.env.PUBLIC_URL + "/MyAccount"}
        element={<MyAccount userPermissions={userPermissions} />}
      />
    </Routes>
  );
};

export default Router;
